
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-to-br from-indigo-600 via-purple-600 to-indigo-800 rounded-xl flex items-center justify-center shadow-lg">
                  <div className="w-6 h-6 bg-white rounded-md flex items-center justify-center">
                    <div className="w-3 h-3 bg-gradient-to-br from-indigo-600 to-purple-600 rounded-sm"></div>
                  </div>
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-gradient-to-r from-yellow-400 to-orange-500 rounded-full"></div>
              </div>
              <div className="flex flex-col">
                <span className="text-xl font-bold leading-tight" style={{ fontFamily: 'Inter, sans-serif' }}>
                  Stupid Deep
                </span>
                <span className="text-xs font-medium text-indigo-400 -mt-1" style={{ fontFamily: 'Inter, sans-serif' }}>
                  CONSULTING
                </span>
              </div>
            </div>
            <p className="text-gray-300 mb-6 max-w-md" style={{ fontFamily: 'Inter, sans-serif' }}>
              We help local businesses launch online and existing e-commerce sellers dominate US market rankings through data-driven strategies and cutting-edge optimization.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-indigo-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-indigo-400 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-indigo-400 transition-colors cursor-pointer">
                <i className="ri-youtube-fill text-xl"></i>
              </a>
              <a href="#" className="text-gray-400 hover:text-indigo-400 transition-colors cursor-pointer">
                <i className="ri-instagram-line text-xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>Quick Links</h3>
            <ul className="space-y-2" style={{ fontFamily: 'Inter, sans-serif' }}>
              <li><Link to="/about" className="text-gray-300 hover:text-indigo-400 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="text-gray-300 hover:text-indigo-400 transition-colors">Services</Link></li>
              <li><Link to="/case-studies" className="text-gray-300 hover:text-indigo-400 transition-colors">Case Studies</Link></li>
              <li><Link to="/blog" className="text-gray-300 hover:text-indigo-400 transition-colors">Blog</Link></li>
              <li><Link to="/contact" className="text-gray-300 hover:text-indigo-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4" style={{ fontFamily: 'Inter, sans-serif' }}>Services</h3>
            <ul className="space-y-2" style={{ fontFamily: 'Inter, sans-serif' }}>
              <li><span className="text-gray-300">SEO Optimization</span></li>
              <li><span className="text-gray-300">E-commerce Setup</span></li>
              <li><span className="text-gray-300">Conversion Optimization</span></li>
              <li><span className="text-gray-300">Digital Marketing</span></li>
              <li><span className="text-gray-300">Analytics & Tracking</span></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm" style={{ fontFamily: 'Inter, sans-serif' }}>
            © {currentYear} Stupid Deep Consulting. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <a 
              href="https://readdy.ai/?origin=logo" 
              className="text-gray-400 hover:text-indigo-400 text-sm transition-colors"
              style={{ fontFamily: 'Inter, sans-serif' }}
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
